// extracted by mini-css-extract-plugin
export var askAiIcon = "_my-9";
export var container = "_my-0";
export var groupSeparator = "_my-a";
export var highlight = "_my-4";
export var resultIcon = "_my-5";
export var resultItem = "_my-7";
export var resultSubtitle = "_my-3";
export var resultTitle = "_my-2";
export var resultsList = "_my-1";
export var searchGroup = "_my-6";
export var selected = "_my-8";